import React from 'react'
import { Modal } from '@components/ui'

type ChartingSelectToothFirstModalProps = {
  show: boolean
  onHide: () => void
}

const ChartingSelectToothFirstModal: React.FC<
  ChartingSelectToothFirstModalProps
> = ({ show, onHide }) => (
  <Modal
    open={show}
    onClose={onHide}
    size="xs"
    title="Select a tooth first"
    description="Please select a tooth number from the dental chart before applying any conditions."
    primaryLabel="Okay"
    secondaryLabel=""
    onPrimaryClick={onHide}
  />
)

export default ChartingSelectToothFirstModal
